import styled, { css } from 'styled-components';
import { colours, common, getColourStates } from 'themes/default';
import { getNewClassOfService } from 'utils/classOfService';

const getCellColour = ({ classOfService, disabled }) => {
  const searchResults = common.searchResults;

  if (disabled) {
    return searchResults.row.disabled || searchResults.row.default;
  }

  const newClassOfService = getNewClassOfService(classOfService);
  const cellColors = searchResults.row[newClassOfService] ?? searchResults.row.default;
  return getColourStates(cellColors);
};

export const PositionedFareProductIndicator = styled.span`
  position: absolute;
  top: 0;
  right: 2px;
  font-size: 12px;
`;

export const StyledLowestFare = styled.div`
  background-color: ${colours.Messaging.SuccessGreenLight};
  width: 100%;
  top: 0;
  height: 20px;
  font-size: 12px;
`;

export const StyledPromoFare = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${colours.Core.CorePink};
  width: 100%;
  top: 0;
  min-height: 20px;
  font-size: 12px;
  line-height: 1.2;
`;

export const StyledSeatsLeft = styled.div`
  background-color: ${colours.Shades.TintBlue10};
  width: 100%;
  bottom: 0;
  height: 20px;
  font-size: 12px;
`;

export const StyledCellContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const StyledFFFeeWarning = styled.div`
  background-color: ${colours.Messaging.WarningOrange};
  width: 100%;
  display: block;
  text-align: center;
  align-self: stretch;
`;

export const StyledProductFammilyMismatch = styled.div`
  font-size: 12px;
`;

export const StyledButton = styled.div`
  align-items: center;
  border-radius: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;
  word-break: break-word;

  &::before {
    content: '';
    display: block;
    height: 0.25rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  ${({ classOfService, disabled }) => {
    const colors = getCellColour({ classOfService, disabled });

    return css`
      background-color: ${colors.backgroundColour};
      color: ${colors.fontColour};

      &::before {
        background-color: ${colors.borderColour};
      }

      &:hover {
        background-color: ${colors.hoverBackgroundColour};
        color: ${colors.hoverFontColour};

        &::before {
          background-color: ${colors.hoverBorderColour};
        }
      }

      &:focus,
      &[data-selected='true'] {
        background-color: ${colors.activeBackgroundColour};
        color: ${colors.activeFontColour};

        &::before {
          background-color: ${colors.activeBorderColour};
        }
      }
    `;
  }}

  ${({ isExistingTrain }) => {
    if (isExistingTrain) {
      return css`
        background-color: ${colours.Messaging.InfoBlueLight};
      `;
    }
  }}
`;

const ClickableCell = {
  StyledButton
};

export default ClickableCell;
